import { FunctionComponent, Suspense, lazy } from 'react'

import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { Route, Routes } from 'react-router-dom'

import { Roles } from 'src/Constants/enums'
import { getUserRole } from 'src/Redux/auth-process/credentialsSlice/selectors'
import TiktokWidgetSearch from 'src/Containers/Widgets/TiktokWidgetSearch'
import { SpotifyWidgetSearch } from 'src/Containers/Widgets/SpotifyWidgetSearch'

import { widgets, tiktokSearch, spotifySearch } from './routes'
import { PublicComponentsNewUI } from './PublicComponentsNewUI'

const ArtistPageLayoutContainer = lazy(() =>
  import('src/Containers/PageLayoutContainer').then((m) => ({
    default: m.ArtistPageLayoutContainer,
  })),
)
const CuratorPageLayoutContainer = lazy(() =>
  import('src/Containers/PageLayoutContainer/CuratorPageLayoutContainer').then(
    (m) => ({ default: m.CuratorPageLayoutContainer }),
  ),
)
const CreatorPageLayoutContainer = lazy(() =>
  import('src/Containers/PageLayoutContainer/CreatorPageLayoutContainer').then(
    (m) => ({ default: m.CreatorPageLayoutContainer }),
  ),
)
const ArtistComponentsNewUI = lazy(() =>
  import('./ArtistComponentsNewUI').then((m) => ({
    default: m.ArtistComponentsNewUI,
  })),
)
const CuratorComponentsNewUI = lazy(() =>
  import('./CuratorComponentsNewUI').then((m) => ({
    default: m.CuratorComponentsNewUI,
  })),
)
const CreatorComponentsNewUI = lazy(() =>
  import('./CreatorComponentsNewUI').then((m) => ({
    default: m.CreatorComponentsNewUI,
  })),
)

const PublicContainer = styled.main``

const Router: FunctionComponent = () => {
  const role = useSelector(getUserRole)

  if (window.location.pathname.includes(`${widgets}`)) {
    return (
      <PublicContainer>
        <Routes>
          <Route
            element={
              <Suspense fallback={null}>
                <TiktokWidgetSearch />
              </Suspense>
            }
            path={`${widgets}${tiktokSearch}`}
          />
          <Route
            element={
              <Suspense fallback={null}>
                <SpotifyWidgetSearch />
              </Suspense>
            }
            path={`${widgets}${spotifySearch}`}
          />
        </Routes>
      </PublicContainer>
    )
  }

  if (role && role === Roles.artist) {
    return (
      <Suspense fallback={null}>
        <ArtistPageLayoutContainer>
          <ArtistComponentsNewUI />
        </ArtistPageLayoutContainer>
      </Suspense>
    )
  }
  if (role && role === Roles.curator) {
    return (
      <Suspense fallback={null}>
        <CuratorPageLayoutContainer>
          <CuratorComponentsNewUI />
        </CuratorPageLayoutContainer>
      </Suspense>
    )
  }

  if (role && role === Roles.influencer) {
    return (
      <Suspense fallback={null}>
        <CreatorPageLayoutContainer>
          <CreatorComponentsNewUI />
        </CreatorPageLayoutContainer>
      </Suspense>
    )
  }

  return <PublicComponentsNewUI />
}

export default Router
